import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './AuthContext';
import { homeFor } from '../lib/portal';

/**
 * Gates the Owner Portal on holding an owner login.
 *
 * The mirror of RequireTenant, and a convenience for the same reason: the real
 * boundary is the server (roles resolved from the database per request) and the
 * owner-scoped row-level security in migration 047. `/api/v1/owner/*` reads the
 * owner id from the signed-in user's own row, and a landlord's row has none, so
 * the call returns nothing owned. This only stops somebody arriving at a shell
 * whose every request would fail.
 */
export function RequireOwner({ children }: { children: ReactNode }) {
  const { isAuthenticated, roles } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!roles.includes('owner_user')) {
    return <Navigate to={homeFor(roles)} replace />;
  }
  return <>{children}</>;
}
